module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/calendar/Birthday.ejs -->\n<i class="fa fa-star" data-toggle="tooltip" data-placement="top"\n    data-html="true"  data-container="body" data-title="\n        <div class=\'tooltip-birthday\\\'>\n            <div class=\'tooltip-header\'>'+
((__t=( header ))==null?'':_.escape(__t))+
'</div>\n            <div class=\'tooltip-description\'>'+
((__t=( description ))==null?'':_.escape(__t))+
'</div>\n        </div>">\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/calendar/Birthday.ejs
// module id = 894
// module chunks = 1